import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";

import { Tooltip, Button, Modal } from "@mantine/core";

import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const COMP_HourlyUsage_ByZone_TotalPC = ({
  _date_selected,
  // _date_selected_ori,
  _day_selected,
  _cafe,
  _pc,
  _total_pc,
  _zone,
  _showMoreInfo,
}) => {
  console.log("xxxxx _date_selected", _date_selected);
  console.log("xxxxx _cafe", _cafe);
  console.log("xxxxx _pc", _pc);
  console.log("xxxxx _zone", _zone);

  const darkGreenShades = [
    "rgba(0, 100, 0, 0.00)", // 0h (fully transparent)
    "rgba(0, 100, 0, 0.04)",
    "rgba(0, 100, 0, 0.08)",
    "rgba(0, 100, 0, 0.12)",
    "rgba(0, 100, 0, 0.16)",
    "rgba(0, 100, 0, 0.20)",
    "rgba(0, 100, 0, 0.24)",
    "rgba(0, 100, 0, 0.28)",
    "rgba(0, 100, 0, 0.32)",
    "rgba(0, 100, 0, 0.36)",
    "rgba(0, 100, 0, 0.40)",
    "rgba(0, 100, 0, 0.44)",
    "rgba(0, 100, 0, 0.48)",
    "rgba(0, 100, 0, 0.52)",
    "rgba(0, 100, 0, 0.56)",
    "rgba(0, 100, 0, 0.60)",
    "rgba(0, 100, 0, 0.64)",
    "rgba(0, 100, 0, 0.68)",
    "rgba(0, 100, 0, 0.72)",
    "rgba(0, 100, 0, 0.76)",
    "rgba(0, 100, 0, 0.80)",
    "rgba(0, 100, 0, 0.84)",
    "rgba(0, 100, 0, 0.88)",
    "rgba(0, 100, 0, 0.92)", // 23h (almost opaque)
  ];

  const FormatDisplay = () => {
    let result = null;

    let OccupencyRate = db_Data?.avg_occupancy_rate ?? 0;
    //   db_Data?.total_pc_count == null
    //     ? "0"
    //     : (
    //         (db_Data?.total_pc_count / db_Data_TotalPC?.total_pc) *
    //         100
    //       )?.toFixed(1);

    // // Ensure OccupencyRate is a number for color calculation
    // let OccupencyRateNum = parseFloat(OccupencyRate);
    // if (isNaN(OccupencyRateNum)) OccupencyRateNum = 0;

    // Map OccupencyRate (0-100) to index (0-23)
    const shadeIdx = Math.min(23, Math.floor(OccupencyRate * 23));
    const bgColor = darkGreenShades[shadeIdx];

    // Extract alpha from rgba string
    const alpha = parseFloat(bgColor?.split(",")?.[3]);
    // If alpha > 0.7, use white text, else black
    const textColor = alpha > 0.7 ? "white" : "black";

    result = (
      <div
        style={{
          marginLeft: "0.1rem",
          marginBottom: "0.1rem",
          backgroundColor: loading ? "transparent" : "white",
          color: loading ? "transparent" : "black",
          width: "70px",
          cursor: "pointer",
        }}
        onClick={() => {
          // get_DB_Data_SelfCheck();
          setModal_Opened(true);
        }}
      >
        {_showMoreInfo ? (
          <div
            style={{
              fontSize: 10,
              padding: "0.2rem",
            }}
          >
            {`🧮${db_Data?.total_pc_count} / ${""} * 100 pc `}
            🔍
          </div>
        ) : null}
        <div
          style={{
            fontSize: 10,
            padding: "0.2rem",
            backgroundColor: loading ? "" : OccupencyRate != 0 ? bgColor : "",
            color: loading ? "transparent" : textColor,
          }}
        >
          <div>{OccupencyRate?.toFixed(3)}</div>
        </div>
      </div>
    );

    return result;
  };

  const [loading, setLoading] = useState(false);

  const [db_Data, setDB_Data] = useState(0);
  // const [db_Data_TotalPC, setDB_Data_TotalPC] = useState(0);
  // const [DB_CafePC_ByCafe, setDB_CafePC_ByCafe] = useState([]);
  const get_DB_Data = async () => {
    console.log(
      `3.3.3 comp get_DB_Data , _date_selected:${_date_selected},_zone:${_zone}`
    );
    setLoading(true);
    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_awesome_pos__cafepc_occupancy_list__monthly`,
        {
          date_YM_selected: _date_selected,
          zone: _zone,
          cafe: _cafe,
        }
      )
      .then((res) => {
        console.log("get_DB_Data xxx", res?.data?.[0]);
        setDB_Data(res?.data?.[0]);
        // console.log("setDB_Data_TotalPC", res?.data?.[1]?.[0]);
        // setTotal_Usage_Sec(res?.data?.[0]?.total_usage_sec);
        // setDB_Data(res?.data?.[0]?.[0]);
        // setDB_Data_TotalPC(res?.data?.[1]?.[0]);
        setLoading(false);
      });
  };

  // const [db_Data_SelfCheck, setDB_Data_SelfCheck] = useState(0);
  // const get_DB_Data_SelfCheck = async () => {
  //   await axios
  //     //REACT_APP_ECLIPSE_API
  //     .post(
  //       `${REACT_APP_ECLIPSE_API}/get_awesome_pos__pcdata_hourly_by_pczonename`,
  //       {
  //         date_YMD_H_selected: _date_selected,
  //         zone: _zone,
  //         cafe: _cafe,
  //         grouped: false, // get total pc list
  //       }
  //     )
  //     .then((res) => {
  //       // console.log("get_DB_Data", res?.data);
  //       setDB_Data_SelfCheck(res?.data);
  //     });
  // };

  const [modal_Opened, setModal_Opened] = useState(false);

  const SelfCheckTable = ({ data }) => {
    console.log(`SelfCheckTable data`, data);

    // const formatTime = ({ secInput }) => {
    //   const h = Math.floor(secInput / 3600);
    //   const m = Math.floor((secInput % 3600) / 60);
    //   const s = secInput % 60;

    //   // Pad with leading zeros if needed
    //   const pad = (n) => String(n).padStart(2, "0");

    //   let result = `${pad(h)}h : ${pad(m)}m : ${pad(s)}s`;
    //   return result;
    // };

    // let totalPC_Used = data?.[0]?.length;
    // let totalPC = data?.[1]?.[0]?.total_pc;
    // let occupencyRate = `${((totalPC_Used / totalPC) * 100)?.toFixed(1)}%`;
    return (
      <>
        slice
        <table border="1" cellPadding="6" cellSpacing="0">
          <thead>
            <tr>
              <td>Cafe</td>
              <td>{"data"}</td>
              <td></td>
            </tr>

            <tr>
              <td>Datetime Range</td>
              <td>{`From : ${""}:00:00`}</td>
              <td>within 1 hour</td>
            </tr>
            <tr>
              <td>Total PC Occupied</td>
              <td>{`${"totalPC_Used"} PC`}</td>
              <td></td>
            </tr>
            <tr>
              <td>Total PC</td>
              <td>{`${"totalPC"} PC `}</td>
              <td></td>
            </tr>
            <tr>
              <td>Total PC Coccupied %</td>
              <td>{`${(data?.ThisDay_Total__pct_PC_Occupied * 100)?.toFixed(
                1
              )}%`}</td>
              <td>{`🧮 Occupency Rate (Full House Rate) = ${data?.ThisDay_Total?.toFixed(
                1
              )}/${data?.DataHourInADay} * 100 = ${(
                data?.ThisDay_Total__pct_PC_Occupied * 100
              )?.toFixed(1)}`}</td>
            </tr>
          </thead>
        </table>
        <br />
        <table
          border="1"
          cellPadding="6"
          cellSpacing="0"
          style={{ width: "100%", background: "black" }}
        >
          <thead>
            <tr>
              <th>#</th>

              <th>In Hour Hit</th>

              <th>Start Time</th>
              <th>End Time</th>
              <th>total_Pc_Occupyied</th>
              <th>total_Pc</th>
              <th>pct_PC_Occupied</th>
            </tr>
          </thead>
          <tbody>
            {data?.Data_ThisMonth_List?.map((row, i) => (
              <tr key={row.id}>
                <td>{i + 1}</td>

                <td>{`${row.selected_dt}:00:00`}</td>

                <td>{row.dlsj_ori}</td>
                <td>{row.jssj_ori}</td>
                <td>{row.total_Pc_Occupyied}</td>
                <td>{row.total_Pc}</td>
                <td>{`${(row.avg_occupancy_rate ?? 0 * 100)?.toFixed(1)}%`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  useEffect(() => {
    get_DB_Data(_cafe, _date_selected);
  }, [_cafe, _zone, _date_selected]);

  return (
    <>
      <Modal
        centered
        opened={modal_Opened}
        onClose={() => setModal_Opened(false)}
        title=""
        size="90%"
      >
        <h1>Under Developing...</h1>
        <SelfCheckTable data={db_Data} />
      </Modal>
      <FormatDisplay />
    </>
  );
};

const Chart_Bar_CafePOS_HeatMap_Hourly_ByZone_TotalPC = ({
  dateSelected,
  cafeSelected,
  pcSelected,
  pczoneSelected,
  total_pc,
  zone,
  showMoreInfo,
}) => {
  //------------------------------------- global var

  //------------------------------------- func

  //------------------------------------- func

  function getDaysInMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed

    // Get the number of days in the month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Create array of days ['1', '2', ..., '31']
    const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
      (i + 1).toString()
    );

    return daysArray;
  }

  function stringToColor(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i); // djb2 hash
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      // Force the value to be in the lower half (darker) of the color spectrum
      const value = Math.abs((hash >> (i * 8)) & 0xff) >> 1; // divide by 2 to keep it dark
      color += value.toString(16).padStart(2, "0");
    }
    return color;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",

          backgroundColor: stringToColor(pczoneSelected),
          gap: 10,
        }}
      >
        <div
          style={{
            width: "160px",
            minWidth: "160px",
            fontSize: 10,
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            marginLeft: 10,
          }}
        >
          <div>📌{pczoneSelected}</div>
        </div>
        <div
          style={{
            width: "70px",
            minWidth: "70px",
            fontSize: 15,
            textAlign: "right",
          }}
        ></div>
        <div
          style={{
            display: "flex",
            gap: 0,
            width: "1400px",
            minWidth: "1400px",
          }}
        >
          {[
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ]?.map((x, i) => {
            return (
              <COMP_HourlyUsage_ByZone_TotalPC
                key={i}
                _date_selected={`${dateSelected?.slice(0, 4)}-${x}`}
                // _date_selected_ori={dateSelected}
                _day_selected={x}
                _cafe={cafeSelected}
                _pc={pcSelected}
                _total_pc={total_pc}
                _zone={zone}
                _showMoreInfo={showMoreInfo}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Chart_Bar_CafePOS_HeatMap_Hourly_ByZone_TotalPC;
